interface CurrencyProps {
    value: number | string; 
    isFormat?: boolean;
    noDecimals?: boolean; 
}

const formatterWithDecimals = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
});

const formatterNoDecimals = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
});

export const formatCurrency = ({ value, isFormat = true, noDecimals = false }: CurrencyProps): string | number => {
    if (isFormat) {
        const parsedValue = typeof value === 'number' ? value : parseFloat(value);
        if (isNaN(parsedValue)) return '';
        return (noDecimals ? formatterNoDecimals : formatterWithDecimals).format(parsedValue);
    } else {
        // Garantir que value é uma string antes de aplicar replace
        const stringValue = typeof value === 'number' ? value.toString() : value;
        const parsedValue = parseFloat(stringValue.replace('R$ ', '').replace(',', '.'));
        if (isNaN(parsedValue)) return '';
        return noDecimals ? Math.round(parsedValue) : parsedValue;
    }
};

/**
 * ## USO
 *
 * - isFormat true --> Transforma value (10) em string formatada (R$ 10,00)
 * - isFormat false --> Transforma value formatado (tipo string) (R$ 10,00) em número (10)
 * - noDecimals true --> Retorna o valor sem casas decimais
 *
 */
